import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Grid } from '@/common/components/Grid/Grid';
import { LabeledValue } from '@/common/components/LabeledValue/LabeledValue';
import { ProfileCard } from '@/common/containers/Dashboard/Profile/components/ProfileCard/ProfileCard';
import { useGetEmployeeTaxProfile } from '@/common/integrations/menhir/employee/employee/employee.hooks';
import { StringUtils } from '@/common/utils/string';
import { MoneyUtils } from '@coverflex-tech/hypernova-utils';
import { TaxProfileFormModal } from './components/TaxProfileFormModal/TaxProfileFormModal';

export function TaxProfileCard() {
  const { t } = useTranslation();
  const { taxProfile } = useGetEmployeeTaxProfile();
  const [isEditing, setIsEditing] = useState(false);

  return (
    <>
      <ProfileCard
        title={t('dashboard.tax_profile.title')}
        onEdit={() => setIsEditing(true)}
      >
        <Grid gap="lg" columnBasis="basis-[12rem]">
          <LabeledValue
            label={t('dashboard.tax_profile.fields.marital_status')}
            value={
              taxProfile?.maritalStatus
                ? t(
                    `dashboard.tax_profile.marital_status.${taxProfile.maritalStatus}`
                  )
                : '—'
            }
          />
          <LabeledValue
            label={t('dashboard.tax_profile.fields.salary')}
            value={
              taxProfile?.salary
                ? MoneyUtils.moneyToString(taxProfile.salary)
                : '—'
            }
          />
          <LabeledValue
            label={t('dashboard.tax_profile.fields.dependents')}
            value={taxProfile?.dependents ? taxProfile.dependents : '—'}
          />
          <LabeledValue
            label={t('dashboard.tax_profile.fields.retention_rate')}
            value={
              taxProfile?.incomeRate
                ? StringUtils.formatPercentage(taxProfile.incomeRate)
                : '—'
            }
          />
        </Grid>
      </ProfileCard>
      {isEditing && (
        <TaxProfileFormModal
          profile={taxProfile}
          onClose={() => setIsEditing(false)}
        />
      )}
    </>
  );
}
